import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8cb90e6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmptyHeroSlider: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/EmptyHeroSlider/index.vue').default,HeroSlider: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/HeroSlider/index.vue').default,Section: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Section/index.vue').default})
